import React, { useEffect, useState } from "react";
import axios from "axios";
import CityCarousel from "./CityCarousel";

const WeatherInfo = () => {
const [location, setLocation] = useState(null);
const [tempC, setTempC] = useState(null);
const [tempF, setTempF] = useState(null);
const[icon, setIcon] = useState("");
const[condition, setCondition] = useState("");
const [city, setCity] = useState("");
const [showModal, setShowModal] = useState(false);

useEffect(() => {
// 1. Get user's geolocation
    if (navigator.geolocation) {    
        navigator.geolocation.getCurrentPosition(
        position => {
            setLocation({
                lat: position.coords.latitude,
                lon: position.coords.longitude,
            });
        },
        error => {
            console.error("Geolocation error:", error);
        }
        );
    } else {
        console.warn("Geolocation is not supported by this browser.");
    }
}, []);

useEffect(() => {
// 2. Once we have location, fetch weather
    const fetchWeather = async () => {
    if (!location) return;

    try {
        const apiKey = '92850d5e4b5f2be21a48502b9f54d522';
        const url = `https://api.openweathermap.org/data/2.5/weather?lat=${location.lat}&lon=${location.lon}&units=metric&appid=${apiKey}`;
        const response = await axios.get(url);
        const celsius = response.data.main.temp;
        const fahrenheit = (celsius * 9) /5 +32;
        console.log(response.data);
        setTempC(celsius);
        setTempF(fahrenheit);
        setIcon(response.data.weather[0].icon);
        setCondition(response.data.weather[0].main);
        setCity(response.data.name);
} catch (error) {
console.error("Weather fetch error:", error);
}
};

fetchWeather();
}, [location]);

return (
    <>
        <div className="weather" onClick={() => setShowModal(true)} style={{ cursor: 'pointer' }}>
            {icon &&(
                <img 
                    src={`https://api.openweathermap.org/img/w/${icon}.png`}
                    alt={condition}
                    style={{verticalAlign: "middle", width: "36px", height : "36px"}}
                />    
            )}    
            <span>{city && `${city}, ${Math.round(tempC)}°C / ${Math.round(tempF)}°F`} </span>
        </div>

        {showModal && (
            <div className="modal-overlay" onClick={() => setShowModal(false)}>
                <div className="modal-content" onClick={e => e.stopPropagation()}>
                    <button onClick={() => setShowModal(false)}>Close</button>
                        <CityCarousel city={city} />
                </div>
            </div>
        )}
    </>
);

}
export default WeatherInfo;


